import React from "react";
import SmartScanDisclaimerPage from "../../components/SmartScanDisclaimer/SmartScanDisclaimerPage";

const SmartScanDisclaimer = () => {
  return (
    <>
      <body className="mobile-body">
        <div className="body-content">
          <section className="review-photo-section py-4 py-md-5">
            <SmartScanDisclaimerPage />
          </section>
        </div>
      </body>
    </>
  );
};

export default SmartScanDisclaimer;
